module.exports = __webpack_public_path__ + "img/孙岩.a876adf8.jpg";